var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-card-foot-stat',{attrs:{"value":_vm.value,"text":"Weight","raw":true,"invalid":_vm.value === 0}})}
var staticRenderFns = []

export { render, staticRenderFns }